import * as React from "react"
import cheerio from "cheerio"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faListUl } from "@fortawesome/free-solid-svg-icons"

const Toc = ({ content }) => {
  const $ = cheerio.load(content)
  const headings = $("h2, h3").toArray()
  const toc = headings.map(data => ({
    text: data.children[0].data,
    id: data.attribs.id,
    name: data.name,
  }))
  return toc.length ? (
    <div
      id="table-of-contents"
      className="border-2 border-gray-200 bg-gray-50 my-6"
    >
      <div className="font-bold p-4 bg-gray-200">
        <FontAwesomeIcon icon={faListUl} className="mr-3" />
        目次
      </div>
      <ul id="in-toc" className="py-2 md:py-4 pl-5 md:pl-9 md:pr-6 list-disc">
        {toc.map(toc => {
          return (
            <li className={"list " + toc.name} key={toc.id}>
              <a href={"#" + toc.id}>{toc.text}</a>
            </li>
          )
        })}
      </ul>
    </div>
  ) : (
    ""
  )
}

export default Toc
